export default {
  title: 'Nova variante',
  fields: {
    product: {
      label: 'Produto',
    },
    name: {
      label: 'Nome',
      placeholder: 'Grande',
    },
    price: {
      label: 'Preço adicional',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Fechar',
  },
  toasts: {
    variant_got_created: 'Variante criada',
    variant_got_updated: 'Variante atualizada',
  },
};
